import { object, ref, string } from "yup";

export const loginValidation = (t) =>
  object().shape({
    username: string()
      .matches(
        /^(05\d{8}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
        t("emailMobileValidation")
      )
      .required(t("emailMobileRequired")),
    password: string().required(t("PasswordRequired")),
  });

export const mobileValidation = (t) =>
  object().shape({
    phone_number: string()
      .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t("telephoneError1"))
      .matches(/^(5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/, t("telephoneError2"))
      .min(9)
      .max(9)
      .required(t("TelephoneRequired")),
  });

export const emailValidation = (t) =>
  object().shape({
    email: string().email(t("invalidEmail")).required(t("emailRequired")),
  });

export const otpValidation = (t) =>
  object().shape({
    otp: string().required(t("Otp is required")),
  });

export const changePasswordValidation = (t) =>
    object().shape({
      password: string()
        .min(8, t('HasAtLeast8Characters'))
        .matches(/[A-Z]/, t('ContainsOneUppercaseLetter'))
        .matches(/[a-z]/, t('ContainsOneLowercaseLetter'))
        .matches(/[0-9]/, t('ContainsOneNumber'))
        .required(t('PasswordRequired')),
      confirmPassword: string()
        .oneOf([ref('password'), null], t('PasswordsMustMatch'))
        .required(t('ConfirmPasswordRequired')),
    });

export const registerValidation = (t) =>
  object().shape({
    firstName: string().required(t("firstnameRequired")),
    lastName: string().required(t("lastnameRequired")),
    // terms: string().required(t("YouMustAcceptTerms")),
    email: string().email(t("invalidEmail")).required(t("emailRequired")),
    phone_number: string()
      .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t("telephoneError1"))
      .matches(/^(5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/, t("telephoneError2"))
      .min(9)
      .max(9)
      .required(t("TelephoneRequired")),
    password: string()
      .min(8, t("HasAtLeast8Characters"))
      .matches(/[A-Z]/, t("ContainsOneUppercaseLetter"))
      .matches(/[a-z]/, t("ContainsOneLowercaseLetter"))
      .matches(/[0-9]/, t("ContainsOneNumber"))
      .required(t("PasswordRequired")),
    confirmPassword: string()
      .oneOf([ref("password"), null], t("PasswordsMustMatch"))
      .required(t("ConfirmPasswordRequired")),
  });
